export default (
  chartsManifest,
  selectedChart,
) => {
  const chartDef = chartsManifest[selectedChart.type];

  const chartNameChunks = [];

  selectedChart.data_sources.forEach((source) => {
    const statDef = chartDef.dataOptions[source.stat];

    if (statDef) {
      let chartNameChunk = `${statDef.labelStr}`;

      if (statDef.categoryDefs && statDef.categoryDefs.length) {
        const cg = statDef.categoryDefs.find((category) => category.category === source.category);
        chartNameChunk += ` ${cg.label}`;
      }

      chartNameChunks.push(chartNameChunk);
    }
  });

  return chartNameChunks.join(', ');
};
